var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 37.159 37.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(-603 429.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rabbillogo",
    transform: "translate(586.67 -445.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(27.374 23.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M116.961,66.562l5.3-7.134,5.3,7.134Z",
    transform: "translate(-110.856 -59.428)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M81.139,112.013l5.3-7.135,5.3,7.135Z",
    transform: "translate(-81.139 -97.133)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M116.455,157.269l5.3-7.135,5.3,7.135Z",
    transform: "translate(-110.437 -134.676)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M81.235,60l5.3,7.134L91.827,60Z",
    transform: "translate(-81.219 -59.903)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M81.645,150l5.3,7.134,5.3-7.134Z",
    transform: "translate(-81.559 -134.565)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M116.455,105l5.3,7.134,5.3-7.134Z",
    transform: "translate(-110.437 -97.234)",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(16.33 16.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M34.91,16.46A18.58,18.58,0,1,0,53.489,35.041,18.6,18.6,0,0,0,34.91,16.46Zm0,35.259A16.679,16.679,0,1,1,51.589,35.04,16.7,16.7,0,0,1,34.91,51.719Z",
    transform: "translate(-16.33 -16.46)",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M163.278,125.489",
    transform: "translate(-121.906 -90.449)",
    fill: "#21A64A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavlogo);
export default __webpack_public_path__ + "static/media/navlogo.23370488fc168f7e8ce9c7874270092a.svg";
export { ForwardRef as ReactComponent };